import community from "../assets/community.svg";
import blockchain from "../assets/blockchain.svg";
import initiative from "../assets/initiative.svg";
export const ourPromiseSource = [
  {
    id: 1,
    image: community,
    title: "Community Led ",
    content:
      "Using a decentralized autonomous organization (DAO), we put power in the hands of our users",
  },
  {
    id: 2,
    image: blockchain,
    title: "Blockchain Powered",
    content:
      "Our platform is powered by blockchain technology, ensuring secure and transparent verification of real-world scenarios through decentralized consensus.",
  },
  {
    id: 3,
    image: initiative,
    title: "Initiatives",
    content:
      "Supporting initiatives for underprivileged people and building trust within and across communities.",
  },
];
